import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins/element.js'
import './assets/css/global.css'
import axios from 'axios'
import { Message } from 'element-ui'

// 去掉末尾 /，避免与数据库里的 /images/... 拼成双斜杠（如 https://host//images/xxx）
const rawApiUrl = (window.__APP_CONFIG__ && window.__APP_CONFIG__.apiUrl) || 'https://storehouse.xin'
const apiUrl = String(rawApiUrl).replace(/\/+$/, '')
Vue.prototype.apiUrl = apiUrl
axios.defaults.baseURL = apiUrl
//请求拦截器
axios.interceptors.request.use(function (config) {
    config.headers.Authorization = localStorage.getItem('adminToken');
    return config
}, function (err) {
    router.push('/login');
    return Promise.reject(err)
})
//响应拦截器
axios.interceptors.response.use(function (res) {
    if (res.data.code == 403) {
        Message.error("请先登录");
        router.push('/login');
        return Promise.reject(res)
    } else {
        return res
    }
}, function (err) {
    Message.error(err.message || "网络错误，请检查接口是否可用");
    return Promise.reject(err)
})

Vue.prototype.$http = axios;

Vue.config.productionTip = false;

// 引入富文本组件
import QuillEditor from 'vue-quill-editor'
// 引入富文本组件样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
Vue.use(QuillEditor)

// 级联下拉打开时，面板宽度与输入框对齐
document.addEventListener('click', (e) => {
    const cascader = e.target && e.target.closest && e.target.closest('.el-cascader')
    if (!cascader) return
    const input = cascader.querySelector('.el-input__inner')
    if (!input) return
    const width = input.getBoundingClientRect().width
    requestAnimationFrame(() => {
        document.querySelectorAll('.el-cascader__dropdown').forEach((dropdown) => {
            const visible = dropdown.style.display !== 'none' && getComputedStyle(dropdown).display !== 'none'
            if (!visible) return
            dropdown.style.minWidth = width + 'px'
            dropdown.querySelectorAll('.el-cascader-menu').forEach((menu) => {
                menu.style.minWidth = width + 'px'
            })
        })
    })
}, true)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
